/**
 * will-change: transform is used as performance improvement in react-virtualized but this style breaks colors
 * (for example color of link custom field on customers list) so remove it
 */
export const virtualListStyleFix = { willChange: <string>null };
